import { createBrowserRouter, Navigate } from 'react-router-dom';
import App from './App';
import ErrorPage from './pages/ErrorPage'; // Import the new ErrorPage component
import Home from './pages/Home';
import About from './pages/About';
import MommyMakeoverPage from './pages/MommyMakeoverPage';
import ClinicsPage from './pages/ClinicsPage';
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';
import BlogsPage from './pages/BlogsPage';
import BlogDetail from './pages/BlogDetail';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import BlogEditor from './pages/BlogEditor';

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '/',
                element: <Home />,
            },
            {
                path: '/about',
                element: <About />,
            },
            {
                path: '/mommy-makeover',
                element: <MommyMakeoverPage />,
            },
            {
                path: '/services',
                element: <ServicesPage />,
            },
            {
                path: '/clinics',
                element: <ClinicsPage />,
            },
            {
                path: '/blogs',
                element: <BlogsPage />,
            },
            {
                path: '/blogs/:id',
                element: <BlogDetail />,
            },
            {
                path: '/contact',
                element: <ContactPage />,
            },
        ],
    },
    // Admin routes (without navbar/footer)
    {
        path: '/admin',
        element: <Navigate to="/admin/dashboard" replace />,
    },
    {
        path: '/admin/login',
        element: <AdminLogin />,
    },
    {
        path: '/admin/dashboard',
        element: <AdminDashboard />,
    },
    {
        path: '/admin/dashbord/blog',
        element: <AdminDashboard />,
    },
    {
        path: '/admin/blog/new',
        element: <BlogEditor />,
    },
    {
        path: '/admin/blog/edit/:id',
        element: <BlogEditor />,
    },
]);

export default router;


